var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8872 25.5386L14.8872 0.538615C14.8028 0.376249 14.6754 0.240167 14.519 0.145195C14.3625 0.0502218 14.183 0 14 0C13.817 0 13.6375 0.0502218 13.4811 0.145195C13.3246 0.240167 13.1972 0.376249 13.1128 0.538615L0.112808 25.5386C0.0335364 25.691 -0.00512702 25.8613 0.000545262 26.033C0.00621755 26.2047 0.0560342 26.3721 0.145192 26.519C0.23435 26.6658 0.359842 26.7872 0.509567 26.8715C0.659293 26.9558 0.828202 27 1.00001 27H27C27.1718 27 27.3407 26.9558 27.4904 26.8715C27.6402 26.7872 27.7657 26.6658 27.8548 26.519C27.944 26.3721 27.9938 26.2047 27.9995 26.033C28.0051 25.8613 27.9665 25.691 27.8872 25.5386ZM12.875 8.00002H15.125V18H12.875V8.00002ZM14 24C13.7033 24 13.4133 23.912 13.1667 23.7472C12.92 23.5824 12.7277 23.3481 12.6142 23.074C12.5007 22.7999 12.471 22.4984 12.5288 22.2074C12.5867 21.9164 12.7296 21.6491 12.9393 21.4394C13.1491 21.2296 13.4164 21.0867 13.7074 21.0288C13.9983 20.971 14.2999 21.0007 14.574 21.1142C14.8481 21.2277 15.0824 21.42 15.2472 21.6667C15.412 21.9133 15.5 22.2033 15.5 22.5C15.5 22.8978 15.342 23.2794 15.0607 23.5607C14.7794 23.842 14.3978 24 14 24Z",
    fill: "#F24326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.6f5983aeb87fb06d0eebda3b08b43612.svg";
export { ForwardRef as ReactComponent };